import * as React from 'react'
import { MultiSelect, Select, Input } from 'uxp/components';
import { IAggregatePanelProps, getDefaultAggregation, getInitialAggregation } from './aggregation-utils';
import { IAggregation, IAggregationType } from '@types';
import styles from './AggregateEditor.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const AggregateEditor: React.FunctionComponent<IAggregatePanelProps> = (props) => {

    const [aggregation, setAggregation] = React.useState<IAggregation>(getDefaultAggregation());

    React.useEffect(() => {
        setAggregation(getInitialAggregation(props?.aggregation));
    }, [props]);

    const handleFieldChange = (index: number, value: string) => {
        const newAggregates = [...aggregation.aggregates];
        newAggregates[index].field = value;
        props.onChange({ ...aggregation, aggregates: newAggregates });
    };

    const handleTypeChange = (index: number, value: IAggregationType) => {
        const newAggregates = [...aggregation.aggregates];
        newAggregates[index].type = value;
        props.onChange({ ...aggregation, aggregates: newAggregates });
    };

    const handleNameChange = (index: number, value: string) => {
        const newAggregates = [...aggregation.aggregates];
        newAggregates[index].name = value;
        props.onChange({ ...aggregation, aggregates: newAggregates });
    };

    const handleGroupByChange = (values: string[]) => {
        props.onChange({ ...aggregation, fields: values });
    };

    const addAggregation = () => {
        const newAggregation = {
            field: '',
            type: '' as IAggregationType,
            name: ''
        };
        const newAggregates = [...aggregation.aggregates, newAggregation];
        props.onChange({ ...aggregation, aggregates: newAggregates });
    };

    const handleRemoveAggregation = (index: number) => {
        const aggregates = [...aggregation.aggregates]
        aggregates.splice(index, 1)
        props.onChange({ ...aggregation, aggregates: aggregates });
    };


    return <div className={styles.aggregationConditionEditorContainer}>

        <div className={styles.aggregationConditionsContainer}>
            {aggregation.aggregates?.length > 0
                ? <div className={styles.aggregationConditions}>
                    {aggregation.aggregates.map((agg, i) => (
                        <div className={styles.aggregationConditionContainer}>
                            <div className={styles.aggregationConditionLabel}>{i == 0 ? 'Get the' : 'and'}</div>
                            <div className={styles.aggregationCondition}>

                                <div className={styles.aggregationConditionInputContainer}>
                                    <Select
                                        selected={agg.type}
                                        onChange={v => handleTypeChange(i, v as IAggregationType)}
                                        options={Object.values(IAggregationType).map(value => ({ label: value, value }))}
                                        className='lucy-query-engine-input'
                                        dropdownClassname="lucy-query-engine-dropdown"
                                    />
                                </div>
                                <div className={styles.aggregationConditionInputContainer}>
                                    <div className={styles.aggregationConditionInputLabel}>of</div>
                                    <div className={styles.aggregationConditionInput}>
                                        <Select
                                            selected={agg.field}
                                            onChange={v => handleFieldChange(i, v as string)}
                                            options={props?.fields || []}
                                            valueField='name'
                                            labelField='name'
                                            className='lucy-query-engine-input'
                                            dropdownClassname="lucy-query-engine-dropdown"
                                        />
                                    </div>
                                </div>
                                <div className={styles.aggregationConditionInputContainer}>
                                    <div className={styles.aggregationConditionInputLabel}>as</div>
                                    <div className={styles.aggregationConditionInput}>
                                        <Input
                                            value={agg.name || ''}
                                            onChange={v => handleNameChange(i, v)}
                                            className='lucy-query-engine-input'
                                        />
                                    </div>
                                </div>

                            </div>
                            <div className={styles.aggregationActions}>
                                <div className={styles.actionButton} onClick={() => handleRemoveAggregation(i)}>
                                    <FontAwesomeIcon icon={['fas', 'trash']} />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                : <div className={styles.noConditions}>No aggregations added</div>
            }

            <div className={styles.aggregationConditionsFooter}>
                <div className={styles.aggregationAddButton} onClick={addAggregation} >+ Aggregation</div>
            </div>
        </div>

        <div className={styles.aggregationGroupByContainer}>
            <div className={styles.aggregationGroupByLabel}>Group By</div>
            <div className={styles.aggregationGroupByInput}>
                <MultiSelect
                    selected={aggregation.fields}
                    onChange={handleGroupByChange}
                    options={props?.fields || []}
                    valueField='name'
                    labelField='name'
                    className='lucy-query-engine-input'
                    dropdownClassname="lucy-query-engine-dropdown"
                />
            </div>
        </div>

    </div>

    return (
        <div className="lucy-query-engine-aggregation-editor-container">
            <div className="lucy-query-engine-aggregation-editor">

                <div className="lucy-query-engine-aggregation-editor-header">
                    <div className="title-group"></div>
                    {/* <div className="action-group">
                        <div
                            className='aggregate-icon aggregate-icon-condition-add child'
                            onClick={addAggregation}
                        ></div>
                    </div> */}
                </div>

                <div className="lucy-query-engine-aggregation-editor-body">

                    <div className="lucy-aggregation-step-row">
                        <div className="lucy-aggregation-step">
                            <div className="aggregation-step-label">Get the </div>
                            <div className="aggregation-step-value">
                            </div>
                        </div>
                    </div>

                    {aggregation.aggregates.map((agg, index) => (
                        <div className="lucy-aggregation-step-row" key={index}>
                            <div className="lucy-aggregation-step-body">

                                <div className="lucy-aggregation-step">
                                    <div className="aggregation-step-value">
                                        <Select
                                            selected={agg.type}
                                            onChange={v => handleTypeChange(index, v as IAggregationType)}
                                            options={Object.values(IAggregationType).map(value => ({ label: value, value }))}
                                            className='query-editor-input'
                                            showEndOfContent={false}
                                        />
                                    </div>
                                </div>

                                <div className="lucy-aggregation-step">
                                    <div className="aggregation-step-label"> of </div>
                                    <div className="aggregation-step-value">
                                        <Select
                                            selected={agg.field}
                                            onChange={v => handleFieldChange(index, v as string)}
                                            options={props?.fields || []}
                                            valueField='name'
                                            labelField='name'
                                            className='query-editor-input'
                                            showEndOfContent={false}
                                        />
                                    </div>
                                </div>

                                <div className="lucy-aggregation-step">
                                    <div className="aggregation-step-label"> as </div>
                                    <div className="aggregation-step-value">
                                        <Input
                                            value={agg.name || ''}
                                            onChange={v => handleNameChange(index, v)}
                                            className='query-editor-input'
                                        />
                                    </div>
                                </div>

                            </div>

                            <div className='action-group'>
                                <div
                                    className='aggregate-icon aggregate-icon-condition-remove child'
                                    onClick={() => handleRemoveAggregation(index)}
                                ></div>
                            </div>

                        </div>
                    ))}
                    <div className='lucy-query-engine-aggregation-add' onClick={addAggregation}>+ Add more</div>

                    <div className="lucy-aggregation-step-row">
                        <div className="lucy-aggregation-step">
                            <div className="aggregation-step-label">Group By</div>
                            <div className="aggregation-step-value">
                                <MultiSelect
                                    selected={aggregation.fields}
                                    onChange={handleGroupByChange}
                                    options={props?.fields || []}
                                    valueField='name'
                                    labelField='name'
                                />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}
